import { Image } from '@cue/atoms';
import { Slider } from '@cue/organisms';
import { IAgendaMap } from '@project/cms/modules';
import { useEffect, useState } from 'react';
export type AgendaMapsProps = {
  data: IAgendaMap[];
  index?: number;
};
export const AgendaMaps = (props: AgendaMapsProps) => {
  const { data, index } = props;
  const [activeIndex, setActiveIndex] = useState(index || 0);
  useEffect(() => {
    setActiveIndex(index || 0);
  }, [index]);
  return (
    <div className="cue-agenda-maps-slider">
      <Image className="ratio-image" src={data[0].image.src} srcSet={data[0].image.srcSet} />
      <Slider
        className="cue-grid-slider  cue-story-slider-modal"
        pagination={false}
        initialSlide={activeIndex}
        loop
        spaceBetween={10}>
        {data.map((map, i) => (
          <Image src={map.image.src} srcSet={map.image.srcSet} key={i} />
        ))}
      </Slider>
    </div>
  );
};
{
  /* <Slider
                className="cue-grid-slider cue-story-slider cue-story-slider-modal"
                pagination={{ enabled: false, clickable: true }}
                spaceBetween={10}>
                {stageMaps.map((map, i) => (
                  <Image src={map.image.src} srcSet={map.image.srcSet} key={i} />
                ))}
              </Slider> */
}
